module.exports = __webpack_public_path__ + "public/img/elevpt.4c5c08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/elevpt.png
// module id = 7JQO
// module chunks = 1